<template>
  <div class="acvitity_foot">
    <div class="acvitity_foot_box">
      <div class="acvitity_foot_left" >
        <div class="custom" @click="consultingClick">
          <img src="../../../assets/img/productDetail/icon_custom.png" alt />
          <span class>咨询</span>
        </div>
      </div>
      <div class="acvitity_foot_right">
        <div class="acvitity_footright_center">
          <div class="buy_btn" :class="[
            buyBtnData.bgColor,
            {
              carBuyUi: buyBtnData.state > 6,
            },
          ]" @click="buyCourse">
            {{ buyBtnData.btnTxt }}
            <p v-if="isShowCouponPrice">
              券后￥{{ dealPrice(allAcvitity.nowAcvitity.promotionPrice) }}
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import moment from 'moment';
import { reqGetGroupProcessing } from '@/api/courseDetail/groupBuy/groupBuy';
import CommonTimer from '@/components/commonComponents/CommonTimer.vue';
import {
  gioPlatform,
  priceCount,
  priceFilterFloat,
  setTokenFromCookie,
  gioEnterCart,
  getRegisterSourceInfo,
} from '@/utils/tools';
import { reqAddCollected, reqCheckCollect, reqCancelCollect } from '@/api/combination';
import collected from '@/assets/img/productDetail/course-colleted.png';
import collect from '@/assets/img/productDetail/course-collet.png';
import { reqReceiveCoupon } from '../../../api/coupon/index';
import FootCommunity from '../courseComponents/footCommunity.vue';
import { setBaseUrl } from '@/utils/tools'

const ua = navigator.userAgent.toLowerCase();
const isIOS = /iphone|ipad|ipod/.test(ua);
const isAndroid = /android/.test(ua) || /ohos/.test(ua); // 判断是否为安卓 兼容鸿蒙

export default {
  components: {
    FootCommunity,
    CommonTimer,
  },
  data() {
    return {
      groupProcessing: {},
      endTime: '',
      iosToLoginFrom: '', // ios中登录判断是从拼团还是普通订单
      gioCourseId: this.$route.query.courseId,
      collect,
      collected,
      isCollect: false, // 是否收藏
      collectInfo: {}, // 当前收藏的数据
      disabled: false, // 能否点击
      actionType: 0, // 1 登录后不需要跳转购买
    };
  },
  props: {
    by_stages_price: {
      type: [Number, String],
      default: 0,
    },
    buyBtnData: {
      type: Object,
      default: () => { },
    },
    type: {
      type: String,
      default: 'course',
    },
    buyBtnLoading: {
      type: Boolean,
      default: false,
    },
    cartCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState(['courseBaseData', 'allAcvitity', 'productSku', 'userInfo', 'buyStatus']),
    // 当前售价
    salePrice() {
      const { sellPrice } = this.courseBaseData;
      const { nowAcvitity, activeType } = this.allAcvitity;
      const { price, productSkuId } = this.productSku;
      let salePrice = 0;
      if (!productSkuId) {
        // 售罄时展示产品中的价格
        salePrice = sellPrice;
      } else if (activeType <= 0 || activeType === 4) {
        // 无活动-展示sku价格
        salePrice = price;
      } else {
        // 活动价格
        salePrice = nowAcvitity?.promotionPrice;
      }
      return salePrice;
    },
    // 是否展示券后价格
    isShowCouponPrice() {
      const { isRepeatBuy } = this.courseBaseData;
      return (
        (this.buyBtnData.state === 10 && !this.buyStatus.length) ||
        (this.buyBtnData.state === 10 && isRepeatBuy === 1)
      );
    },
  },
  watch: {},
  created() { },
  mounted() {
    const that = this;
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = that.getLogin;
    }, 100);
    this.getGroupInfo();
    this.reqCollect();
  },
  destroyed() { },
  methods: {
    goGroupProcess() {
      this.$router.push({
        path: '/groupProgress',
        query: {
          groupId: this.groupProcessing.groupId,
        },
      });
    },
    async getGroupInfo() {
      const { courseId } = this.$route.query;
      const res = await reqGetGroupProcessing({ productId: courseId });
      if (res.code === 0 && res.data) {
        this.groupProcessing = res.data;
        if (this.groupProcessing.status === 2) {
          this.endTime = moment(this.groupProcessing.endTime).format('X');
        }
      }
    },
    groupPersonNum() {
      const { groupNumber, joinNumber } = this.groupProcessing;
      const num = groupNumber - joinNumber;
      return num > 0 ? num : '';
    },
    // 价格小数位处理
    calculationPrice(price) {
      return priceCount(price);
    },
    dealPrice(price) {
      return priceFilterFloat(price);
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      this.$parent.getCouponGiftList();
      await this.$parent.getCourseDetail();
      if (this.actionType === 1) return;
      if (this.iosToLoginFrom === 'groupBuy') {
        this.openGroupOrder();
        this.iosToLoginFrom = '';
      } else {
        // 登录后不再提交订单
        this.jumpPayOrder('disbaledBuy');
      }
    },
    // ios 处理登录回调
    getLogin(APPSESSION) {
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    // // 注册来源
    getSourceData(type) {
      // 4免费课程 5付费课程
      const sourceType = this.buyBtnData?.state === 6 ? 4 : 5;
      getRegisterSourceInfo(this, 'courseDetail', sourceType, type);
    },

    buyCourse() {
      this.actionType = 0;
      const { state } = this.buyBtnData;
      const { isApp = false } = this.$root.$data;
      if (state === 11) {
        this.consultingClick();
        return false;
      }
      // 不可购
      if (state <= 4) {
        this.notCanBuy(state);
        return false;
      }
      // 导学页
      if (state === 5) {
        this.goDirectoryPage();
        return false;
      }
      if (!this.productSku.productSkuId) {
        this.$toast('未获取到选中sku信息，请刷新页面');
        return false;
      }
      // 外部产品跳转
      const { productSkipConfigRespVO } = this.courseBaseData;
      if (productSkipConfigRespVO?.source === 1) {
        if (this.$root.$data.isApp) {
          if (productSkipConfigRespVO?.skipType === 0) {
            // 外部产品
            this.$sendToApp('openBrowser', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
          } else if (productSkipConfigRespVO?.skipType === 1) {
            this.$sendToApp('openTaobao', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
          }
        } else {
          window.open(productSkipConfigRespVO?.mobileSkipUrl);
        }
        return false;
      }
      // 下单
      if (this.userInfo.id) {
        if (!this.buyBtnLoading) {
          this.jumpPayOrder();
        }
      } else if (this.$root.whatEev == 'miniprogram' && !this.userInfo.id) {
        let miniCourseFree = state === 6 ? true : false;
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            //  console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}miniCourseFree=${miniCourseFree}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
        return;
      } else if (!isApp) {
        if (state === 6) {
          // 免费课程时传free 1
          const queryParam = { free: '1', redirect: '/courseDetail', ...this.$route.query };
          this.$router.push({ path: '/registrationLogin', query: queryParam });
        } else {
          this.$router.push({
            path: '/registrationLogin',
            // query: { redirect: '/courseDetail', courseId: this.$route.query.courseId },
            query: { redirect: '/courseDetail', ...this.$route.query },
          });
        }
      } else if (isIOS) {
        this.getSourceData(false);
      } else if (isAndroid) {
        const sourceType = this.buyBtnData?.state === 6 ? 4 : 5;
        const address = `${window.location.origin}/ark/courseDetail${window.location.search}`;
        this.$sendToApp('newLogin', { clientType: sourceType, address }, true)
          .then(async () => {
            setTokenFromCookie();
            await this.$root.getUserInfo();
            this.jumpPayOrder();
          })
          .catch((err) => console.log(err.toString()));
      }
      return true;
    },
    openGroup() {
      if (!this.$root.miniprogramBuyCourse && this.$root.miniprogram) {
        this.consultingClick();
        return;
      }
      this.actionType = 0;
      const { isApp = false } = this.$root.$data;
      // 外部产品跳转
      const { productSkipConfigRespVO } = this.courseBaseData;
      if (productSkipConfigRespVO?.source === 1) {
        if (this.$root.$data.isApp) {
          if (productSkipConfigRespVO?.skipType === 0) {
            // 外部产品
            this.$sendToApp('openBrowser', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
          } else if (productSkipConfigRespVO?.skipType === 1) {
            this.$sendToApp('openTaobao', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
          }
        } else {
          window.open(productSkipConfigRespVO?.mobileSkipUrl);
        }
        return;
      }
      if (this.userInfo.id) {
        this.openGroupOrder();
      } else if (!isApp) {
        this.$router.push({
          path: '/registrationLogin',
          // query: { redirect: '/courseDetail', courseId: this.$route.query.courseId },
          query: { redirect: '/courseDetail', ...this.$route.query },
        });
      } else if (isIOS) {
        this.iosToLoginFrom = 'groupBuy';
        this.getSourceData(false);
      } else if (isAndroid) {
        const sourceType = this.buyBtnData?.state === 6 ? 4 : 5;
        const address = `${window.location.origin}/ark/courseDetail${window.location.search}`;
        this.$sendToApp('newLogin', { clientType: sourceType, address }, true)
          .then(async () => {
            setTokenFromCookie();
            await this.$root.getUserInfo();
            this.openGroupOrder();
          })
          .catch((err) => console.log(err.toString()));
      }
    },
    // 付费课购买
    jumpPayOrder(status) {
      if (this.allAcvitity.activeType === 4) {
        // 领取优惠券
        this.isReceiveCoupon(this.allAcvitity.couponDetailVO.couponId);
      }
      this.$parent.checkBuy(status);
    },
    openGroupOrder() {
      if (!this.buyBtnLoading) {
        this.$parent.jumpPayOrder1({
          source: 'group',
          data: this.allAcvitity.productGroupActivityDiscount,
        });
      }
    },
    async isReceiveCoupon(couponId) {
      const couponData = this.allAcvitity.couponDetailVO.couponChooseRespList.find(
        (item) => item.couponId === couponId,
      );
      if (couponData.hasGetAlready) return;
      /**
       * 区分app
       * 校验登录
       * 平台类型参数
       */
      const res = await reqReceiveCoupon({
        couponId: couponData.couponId,
        couponVersion: couponData.couponVersion,
        fitEndPoint: this.$root.$data.isApp ? 2 : 4,
        fitPlatform: 1,
        isPrivateCoupon: 0,
        terminalMark: this.$global.terminalMark,
      });
      if (res.code === 0) {
        this.$toast('领取成功');
        this.gioEvent(this.allAcvitity.couponDetailVO.couponChooseRespList);
      } else {
        this.$message.error(res.msg);
      }
    },
    // 不可购买提示语
    notCanBuy(state) {
      let msg = '';
      switch (state) {
        case 0:
          msg = '当前课程未配置课表，如需购买，请联系客服';
          break;
        case 1:
          msg = '当前课程还未上架，如需购买，请联系客服';
          break;
        case 2:
          msg = '当前课程已下架，如需购买，请联系客服';
          break;
        case 3:
          msg = '当前课程已过期，如需购买，请联系客服';
          break;
        case 4:
          msg = '当前课程已售罄，如需购买，请联系客服';
          break;
        case -101000:
          msg = '请稍等';
          break;
        default:
          msg = '';
      }
      this.$toast(msg);
    },
    // 跳转 导学页（原生交互） h5页面需要弹窗提示去app查看
    goDirectoryPage() {
      const { isApp = false } = this.$root.$data;
      if (isApp) {
        this.$sendToApp('goDirectoryPage', { courseId: this.buyStatus[0]?.id }, false);
      } else {
        this.$emit('openAppDialog');
      }
    },
    consultingClick() {
      const { baseBusinessLine } = this.courseBaseData
      const flag = (baseBusinessLine && baseBusinessLine === 2); // 判断是否专申本业务线
      const baseUrl = setBaseUrl(9)
      // const urlH5 = `${baseUrl}/chat/m_page?probeId=${25}&token=${localStorage.getItem('accessToken')}&landingPageUrl=${window.location.href}`
      const urlH5 = 'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=67653fd704b13300018ae145';
      const urlMini = `${baseUrl}/chat/m_page?probeId=${26}&token=${localStorage.getItem('accessToken')}&landingPageUrl=${window.location.href}`
      const url = 'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=689c302a873d7d0001e78a48';
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: flag ? url : urlH5,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        if (flag) {
          wx.miniProgram.navigateTo({
            url: `/pages/suctomerService/index`,
          });
        } else {
          wx.miniProgram.navigateTo({
            // url: `/subPackages/aiChatProdWebview/index?probeId=26`,
            url: `/subPackages/mantisChat/mantisChat?chatPageUrl=${encodeURIComponent(`https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=${'67653ff19d78140001e5277e'}`)}&probeId=${'67653ff19d78140001e5277e'}`,
          });
        }
        return;
      }
      window.open(flag ? url : urlH5);
    },
    gioEvent(item) {
      const { couponId, couponName, discountType } = item;
      // eslint-disable-next-line
      let disType = discountType === 1 ? '满减' : discountType === 2 ? '打折' : null;
      // 领取优惠券
      // eslint-disable-next-line
      gio('track', 'getCoupon_event', {
        getPage_var: '课程详情页面',
        courseId_var: this.gioCourseId ? this.gioCourseId.toString() : null, // 在课程详情页领取的卡券，该变量才会有值
        couponIdList_var: couponId,
        couponTypeList_var: disType, // 卡券类型列表
        couponNameList_var: couponName,
        platform_var: gioPlatform(),
      });
    },
    // 是否收藏
    async reqCollect() {
      const { courseId } = this.$route.query;
      const { data } = await reqCheckCollect(courseId, 1);
      this.isCollect = !!data;
      this.collectInfo = data;
    },
    checkCollect() {
      const { courseId } = this.$route.query;
      const { isCollect, collectInfo } = this;
      // login
      if (!this.userInfo?.id) {
        this.actionType = 1;
        if (!this.$root.$data.isApp) {
          if (this.buyBtnData?.state === 6) {
            this.$router.push({
              path: '/registrationLogin',
              query: { free: '1', redirect: '/courseDetail', ...this.$route.query },
            });
          } else {
            this.$router.push({
              path: '/registrationLogin',
              query: { redirect: '/courseDetail', ...this.$route.query },
            });
          }
        } else if (isIOS) {
          this.getSourceData(false);
        } else if (isAndroid) {
          this.getSourceData(true);
        }
        return;
      }
      if (this.disabled) {
        return;
      }
      this.disabled = true;
      if (!isCollect) {
        this.addCollect(courseId);
      } else {
        this.cancelCollect(collectInfo.id);
      }
      setTimeout(() => {
        this.disabled = false;
      }, 1000);
    },
    // 添加收藏
    async addCollect(courseId) {
      const { code, msg } = await reqAddCollected({
        sourceId: courseId,
        type: 1,
      });
      if (code === 0) {
        const { name } = this.courseBaseData;
        this.$toast(this.$root.$data.isApp ? '收藏成功' : '收藏成功，可在启航教育APP查看');
        this.reqCollect();
        gio('track', 'collect_event', {
          courseId_var: courseId.toString(),
          courseName_var: name,
          platform_var: gioPlatform(),
        });
      } else {
        this.$toast(msg);
      }
    },
    // 取消收藏
    async cancelCollect(id) {
      const { code, msg } = await reqCancelCollect(id);
      if (code === 0) {
        this.$toast('已取消收藏');
        this.reqCollect();
      } else {
        this.$toast(msg);
      }
    },
    openMiniLogin() {
      let url = window.location.href;
      const [domain, searchParams] = url.split('?');
      if (searchParams) {
        const params = searchParams.split('&');
        const paramsMap = new Map();
        params.forEach((item) => {
          const [key, value] = item.split('=');
          //  console.log('key', key, value);
          if (key) {
            paramsMap.set(key, value);
          }
        });
        const entries = paramsMap.entries();
        let query = '';
        const ExcludequeryArr = ['THIRD_SESSION', 'env'];
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of entries) {
          if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
        }
        url = `${domain}?${query}`;
        const redirctUrl = encodeURIComponent(
          `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
        );
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
      }
    },
    // 加入购物车按钮
    addShoppingCar() {
      if (!this.userInfo?.id) {
        if (this.$root.miniprogram) {
          this.openMiniLogin();
        } else if (!this.$root.$data.isApp) {
          const queryParam = { redirect: '/courseDetail', ...this.$route.query };
          this.$router.push({ path: '/registrationLogin', query: queryParam });
        } else if (isIOS) {
          this.getSourceData(false);
        } else if (isAndroid) {
          this.getSourceData(true);
        }
        return;
      }
      // 外部产品跳转
      const { productSkipConfigRespVO } = this.courseBaseData;
      if (productSkipConfigRespVO?.source === 1) {
        if (this.$root.$data.isApp) {
          if (productSkipConfigRespVO?.skipType === 0) {
            // 外部产品
            this.$sendToApp('openBrowser', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
          } else if (productSkipConfigRespVO?.skipType === 1) {
            this.$sendToApp('openTaobao', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
          }
        } else {
          window.open(productSkipConfigRespVO?.mobileSkipUrl);
        }
        return;
      }
      this.$parent.checkAddShopCar();
    },
    // 查看购物车列表
    goShoppingCar() {
      // login
      if (this.$root.miniprogram && !this.userInfo?.id) {
        this.openMiniLogin();
      } else if (!this.userInfo?.id) {
        if (!this.$root.$data.isApp) {
          this.$router.push({
            path: '/registrationLogin',
            query: { redirect: '/shoppingCar', beforePageName: 1 },
          });
          gioEnterCart(1);
        } else if (isIOS) {
          this.$sendToApp('login', {}, false);
        } else if (isAndroid) {
          this.$sendToApp('login', {}, true)
            .then(async () => {
              setTokenFromCookie();
              await this.$root.getUserInfo();
            })
            .catch((err) => console.log(err.toString()));
        }
        return;
      }

      this.$router.push({
        path: '/shoppingCar',
        query: {
          beforePageName: 1,
        },
      });
      gioEnterCart(1);
    },
  },
};
</script>
<style scoped lang="scss">
.acvitity_foot {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 120px;
  background: #fff;
  box-shadow: 0 -4px 7px 0 rgba(0, 0, 0, 0.05);

  .acvitity_foot_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 120px;
    padding: 0 30px;
  }

  .group-buy-foot {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 120px;
    padding: 0 36px;
    background: #fff;
    box-shadow: 0 -4px 7px 0 rgba(0, 0, 0, 0.05);

    .group-buy-foot-left {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    .foot-consult {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 15px;
      font-size: 24px;

      img {
        width: 43px;
        margin-bottom: 4px;
      }
    }

    .foot-btn-div.mini {
      .btn {
        width: 236px;
      }
    }

    .foot-btn-div {
      display: flex;

      .btn.miniNotBuy {
        width: 400px;

        span:first-child {
          display: none;
        }
      }

      .btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-width: 216px;
        height: 82px;
        color: white;
        font-size: 25px;
        background: $theme_color;
        border-radius: 44px;

        span {
          line-height: 34px;
        }
      }

      .light-color-btn {
        margin-right: 29px;
        background: $btnLightColor;
      }
    }
  }
}

.acvitity_foot_left {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.custom {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 36px;

  img {
    display: block;
    width: 47px;
  }

  span {
    color: #333;
    font-size: 18px;
    line-height: 30px;
    white-space: nowrap;
  }
}

.acvitity_foot_right {
  display: flex;
  align-items: center;

  // justify-content: flex-end;
  .addShopCar {
    width: 210px;
    height: 80px;
    color: #fff;
    font-weight: 500;
    font-size: 27px;
    line-height: 80px;
    text-align: center;
    background: linear-gradient(90deg, #fed319 0%, #ffbc1f 100%);
    border-radius: 45px 0 0 45px;
  }

  .acvitity_footright_center {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    // .buy_btn.mini {
    //   width: 400px;
    // }

    .buy_btn {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      width: 598px;
      height: 82px;
      // line-height: 80px;
      color: #fff;
      font-size: 27px;
      text-align: center;
      background: linear-gradient(90deg, #ff6c02 0%, #ff7f41 100%);
      border-radius: 45px;
    }

    .buy_btn.coupon {
      padding: 12px 0;
      font-size: 25px;

      p {
        width: 100%;
        font-size: 22px;
        line-height: 32px;
      }
    }
  }

  .buy_btn.notBuy,
  .buy_btn.sellOut {
    background: #ccc;
  }
}

.carBuyUi {
  // border-radius: 0 45px 45px 0 !important;
}

.carIconBtn {
  position: relative;

  img {
    display: block;
    width: 44px;
    height: 44px;
    margin: 0 auto;
  }

  span {
    display: block;
    color: #333;
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
  }

  .carNum {
    position: absolute;
    top: -10px;
    right: 0;
    display: block;
    width: 30px;
    height: 30px;
    color: #fff;
    font-weight: 500;
    font-size: 18px;
    font-style: normal;
    line-height: 30px;
    text-align: center;
    background: #ff472d;
    border: 2px solid #fff;
    border-radius: 50%;
  }
}
</style>
